import * as React from 'react';
import { SVGProps } from 'react';
const SvgIcWaiting = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={32}
    height={32}
    viewBox="0 0 32 32"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M25.736 4.007 18.457 16.56l7.377 11.447H6.171l7.337-11.448-7.24-12.552h19.468Zm-7.429 8.822-4.008 1.1 1.55 2.686-6.021 9.391h12.337l-6.052-9.391 2.194-3.786Zm3.957-6.823H9.731l3.535 6.132 6.471-1.774 2.527-4.358Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);
export default SvgIcWaiting;
